import React, { useEffect, useState, useRef } from 'react';
import './SubmitDocumentsRequestiframe.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { showToast } from '../toastUtils';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';
const MySwal = withReactContent(Swal);
const formData = new FormData();

function SubmitDocumentsRequestiframe({ buttonId }) {
  const accountId = localStorage.getItem('accountId');
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const defaultProjectNumber = selectedProjectDetail.projectNumber;
  const defaultURN = selectedProjectDetail.URN;
  const urnlist = selectedProjectDetail.URN_List;
  const URNoutput = defaultURN ? defaultURN.replaceAll(":", "%3A"): '';
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';
  const [loading, setLoading] = useState(true);
  const [userRoleManual, setUserRolesManual] = useState([]);
  const [proj_access_level, setProjAccessLevel] = useState(false);
  // console.log('Role', userRoleManual);

  //new code updations
  // const getUserDetails = localStorage.getItem('userDetails');
  // const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
  // const userId = userDetails ? userDetails.id : '';
  const getUserAccess = userDetails ? userDetails.access_level : '';
  const [userCompany, setUserCompany] = useState();
  const getUserCompanyDetails = userCompany;
  const getUserEmail = localStorage.getItem('userEmail');
  const [userPermission, setUserPermission] = useState();
  let parametervalue = 0;
  // const cons=userRoleManual.indexOf('Consultant');
  // const cont=userRoleManual.indexOf('Contractor');
  // console.log('getUserCompanyDetails', getUserCompanyDetails);
  // console.log('userPermission', userPermission);
  // console.log('role', userRoleManual);
  //Parameter passing
  if (getUserCompanyDetails === "NUS") {
    parametervalue = 1;
  } else {
    parametervalue = 0;
  }

  let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
  let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");
  let proj_name=selectedProjectDetail?.projectName;

  let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;

  const GlobalPermissionChecker = (
    expectedCompany,
    // accountAdminPermissions = [],
    projectAdminRoles = []
  ) => {
    const sts = (
      // (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && userRoleManual === '') ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.includes(userRoleManual))

      // (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && userRoleManual.length===0) ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.some(item=>userRoleManual?.includes?.(item))) ||
      // (getUserCompanyDetails != expectedCompany && userPermission === 'project_admin' && projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))

      (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) ||
      (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && projectAdminRoles.some(item => userRoleManual?.includes?.(item))) ||
      (getUserCompanyDetails != expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && projectAdminRoles.some(item => userRoleManual?.includes?.(item)))

    );
    return sts;
  };

  const fetchUserRole = async () => {
    if (!userId || !defaultProjectNumber) {
      return;
    }
    const requestOptions = {
      method: 'GET',
      // //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      //d58b7e9f-a71f-4bc5-8736-1005455aad44
      // const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
      const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data); 
        //setUserRolesManual(data.data);         
        //data.data[0]='Consultant';
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
        //setUserRolesManual(['Consultant']);
        //setUserRolesManual('Contractor');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      // setTimeout(() => {
      //     setLoading(false);
      //   }, 3000); 

    }
  }

  const fetchUserCompany = async () => {
    const requestOptions = {
      method: 'GET',
      // //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      // const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        //data.data.access_level='project_admin';
        setUserPermission(data.data.access_level);
        //setUserCompany('BIMAGE');
        //setUserPermission('project_user');     
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // End loading
    }
  }

  useEffect(() => {
    fetchUserCompany();
    fetchUserRole();
  }, []);

      const performance_Bond = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.per_bond}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const insurance_Bond = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.ins_bond}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const SOI_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.issue_soi}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const FSC_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.fsc}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const CSC_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.csc}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const TOP_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.top}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const PIR_UPLOAD_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.pir_upload}&viewModel=detail&moduleId=folders&${qs_params}&menu=Post Construction_Submit Form`;
      const PIR_PROCEED_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/cd91139e-f265-5576-86a8-91ec2543a29e/reports/9c6bd749-6c8a-497b-9a49-103ab9f8a8a8?${qs_params}`;
      const CAP_URL = `https://acc.autodesk.com/docs/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.capt_form}&viewModel=detail&moduleId=folders&${qs_params}&menu=Post Construction_Submit Form`;
      const FIN_URL = `https://acc.autodesk.com/docs/reviews/projects/${defaultProjectNumber}?pageIndex=1&sort=-sequenceId&${qs_params}&menu=Post Construction_Submit Form`;
      const FAC_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.fac_permits}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const SIT_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/7f7ee86b-3705-524b-99bc-b2cef7964d4e/reports/49f0f735-7592-46c8-bece-cb5b14eabcf7?${qs_params}`;
      const SIT_UTI_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/c3fc4358-c66e-5c02-af5c-929cd7e808da/reports/f8b01a8c-91f7-4996-8593-360a9185f152?${qs_params}`;
      const FM_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/e7f3e336-9b78-5bcd-95b3-775e413091e3/reports/f32b040c-5e40-4c2b-8a47-9c896a18f674?${qs_params}`;
      const EOT_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.eot_req}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const DOC_URL = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.other_docs}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Submit Documents/Request`;
      const ISO_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/f003b58f-9800-55e8-ae2c-d6aa0265e033/reports/dad1fc4f-4562-4339-8f31-dae758818851?${qs_params}&menu=Construction_Submit Documents/Request`;
      const INS_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/84a03537-9e23-5253-817f-d9908626274b/reports/04db5ddc-c3e4-4cfe-89ef-e291779d27ec?${qs_params}`;
      const PROJ_CHECKLIST = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/fc1d163d-c687-5d5e-9096-8ba71486b78a/reports/b40cd6e6-f12c-4239-8d58-ab92a15a9361?${qs_params}`;
      const APPR_CONTRACTOR = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/8d459e12-ab09-5003-830a-930082bf4c96/reports/0a66b7d1-4c1c-45ee-b756-39c975ebc25d?${qs_params}`;
      const APPR_CONSULTANT = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/0b1f665f-5cc5-545c-b95c-64831078d00e/reports/ebbeff12-ea3a-41b4-a067-0b370b2e9cfa?${qs_params}`;
      

  const t_site_ho_cont='Site Handover to Contractor';
  const t_site_uti_plan='Site Utilization Plan';
  const t_high_imp_work='High Impact Work';
  const t_inst_req='Installation Request';
  const t_pir_form='PIR';
  const t_proj_checklist='Project Checklist';
  const t_cons_appraisal='Consultant appraisal form';
  const t_cont_appraisal='Contractor appraisal form';
  const t_iso_works_form='Isolation Works';

  
  // const openBondPopup = () => {
  //   MySwal.fire({
  //     title: '',
  //     html: `            
  //           <div className="popup-container">        
  //         <div className="popup-body">
  //         <div className="popup-field">
  //           <label for="selectSubmission">Select Submission *</label>
  //           <select id="selectSubmission" style="width: 200px; border-radius: 0;" className="popup-input">
  //           <option value="" selected>Select Submission</option>
  //             <option value="Performance Bond">Performance Bond</option>
  //             <option value="Insurance Bond">Insurance Bond</option>
  //           </select>
  //         </div>

  //         <div className="popup-field">
  //             <label for="expiryDate">Expiry Date *</label>
  //             <input style="width: 200px; border-radius: 0;" id="expiryDate" type="date" className="popup-input">
  //           </div>

  //         <div className="popup-field">
  //               <label for="submissionType">Submission Type *</label>
  //               <select id="submissionType" style="width: 200px; border-radius: 0;" className="popup-input">
  //               <option value="" selected>Submission Type</option>
  //                   <option value="Soft Copy">Soft Copy</option>
  //                   <option value="Hard copy">Hard copy</option>
  //               </select>
  //           </div>            
  //         </div>
  //       </div>
  //         `,
  //     showCancelButton: true,
  //     confirmButtonText: 'Submit',
  //     cancelButtonText: 'Cancel',
  //     focusConfirm: false,
  //     customClass: {
  //       popup: 'custom-popup',
  //       cancelButton: 'cancel-button',
  //       confirmButton: 'bond-confirm-button',
  //       actions: 'custom-actions',
  //     },
  //     reverseButtons: false,
  //     allowOutsideClick: false,
  //     preConfirm: async () => {
  //       const selectSubmission = document.getElementById('selectSubmission').value;
  //       const expiryDate = document.getElementById('expiryDate').value;
  //       const submissionType = document.getElementById('submissionType').value;

  //       if (!expiryDate || !selectSubmission || !submissionType) {
  //         Swal.showValidationMessage('Please fill out all required fields');
  //         return false;
  //       }
  //       const sendData = {
  //         bim360_account_id: accountId,
  //         user_id: userId,
  //         user_group: process.env.REACT_APP_USER_GROUP,
  //         project_id: defaultProjectNumber,
  //         submission: selectSubmission,
  //         expiry_date: expiryDate,
  //         submission_type: submissionType,
  //       };

  //       // console.log('sendData....',sendData);
        
  //       try {
  //         Swal.showLoading();

  //         const requestOptions = {
  //           method: 'POST',
  //           // headers: {
  //           //   'Content-Type': 'application/json',
  //           //   'ngrok-skip-browser-warning': '69420',
  //           // },
  //           body: JSON.stringify(sendData),
  //         };

  //         const response = await queuedApiFetch('/construction/insert_update_per_ins_bond', requestOptions);
  //         const result = await response;

  //         if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {            
  //           // showToast.success('Project Created Successfully');
  //           // return true; // Close the popup
  //           if(selectSubmission == 'Performance Bond'){
  //             window.location.href = performance_Bond;
  //             return true;
  //           } else {
  //             window.location.href = insurance_Bond;
  //             return true;
  //           }
  //         } else {
  //           Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
  //           return false;
  //         }
  //       } catch (error) {
  //         console.error('Error saving data:', error);
  //         Swal.showValidationMessage('Something went wrong. Please try again.');
  //         return false;
  //       }
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       console.log('Project created successfully!');
  //     }
  //   }).catch((errorMessage) => {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: errorMessage,
  //     });
  //   });
  // };

//   const openBondPopup = () => {
//   MySwal.fire({
//     title: '',
//     width: 450,
//     html: `
//       <div style="font-family: Arial, sans-serif;">
//         <style>
//           .popup-body {
//             display: flex;
//             flex-direction: column;
//             gap: 16px;
//             width: 100%;
//             max-width: 320px;
//             margin: 0 auto;
//           }
//           .popup-field {
//             display: flex;
//             flex-direction: column;
//             text-align: left;
//           }
//           .popup-field label {
//             font-size: 14px;
//             font-weight: 600;
//             color: #333;
//             margin-bottom: 5px;
//           }
//           .popup-input {
//             width: 100%;
//             padding: 7px 10px;
//             border: 1px solid #ccc;
//             border-radius: 6px;
//             font-size: 14px;
//           }
//           .popup-input:focus {
//             outline: none;
//             border-color: #007bff;
//             box-shadow: 0 0 3px rgba(0, 123, 255, 0.3);
//           }
//         </style>

//         <div class="popup-body">

//           <div class="popup-field">
//             <label for="selectSubmission">Select Submission *</label>
//             <select id="selectSubmission" class="popup-input">
//               <option value="" selected>Select Submission</option>
//               <option value="Performance Bond">Performance Bond</option>
//               <option value="Insurance Bond">Insurance Bond</option>
//             </select>
//           </div>

//           <div class="popup-field">
//             <label for="expiryDate">Expiry Date *</label>
//             <input id="expiryDate" type="date" class="popup-input" />
//           </div>

//           <div class="popup-field">
//             <label for="submissionType">Submission Type *</label>
//             <select id="submissionType" class="popup-input">
//               <option value="" selected>Submission Type</option>
//               <option value="Soft Copy">Soft Copy</option>
//               <option value="Hard copy">Hard copy</option>
//             </select>
//           </div>

//         </div>
//       </div>
//     `,
//     showCancelButton: true,
//     confirmButtonText: 'Submit',
//     cancelButtonText: 'Cancel',
//     focusConfirm: false,
//     customClass: {
//       popup: 'custom-popup',
//       cancelButton: 'cancel-button',
//       confirmButton: 'bond-confirm-button',
//       actions: 'custom-actions',
//     },
//     reverseButtons: false,
//     allowOutsideClick: false,

//     preConfirm: async () => {
//       const selectSubmission = document.getElementById('selectSubmission').value;
//       const expiryDate = document.getElementById('expiryDate').value;
//       const submissionType = document.getElementById('submissionType').value;

//       if (!expiryDate || !selectSubmission || !submissionType) {
//         Swal.showValidationMessage('Please fill out all required fields');
//         return false;
//       }

//       const sendData = {
//         bim360_account_id: accountId,
//         user_id: userId,
//         user_group: process.env.REACT_APP_USER_GROUP,
//         project_id: defaultProjectNumber,
//         submission: selectSubmission,
//         expiry_date: expiryDate,
//         submission_type: submissionType,
//       };

//       try {
//         Swal.showLoading();
//         const requestOptions = {
//           method: 'POST',
//           body: JSON.stringify(sendData),
//         };

//         const response = await queuedApiFetch('/construction/insert_update_per_ins_bond', requestOptions);
//         const result = await response;

//         if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
//           if (selectSubmission === 'Performance Bond') {
//             window.location.href = performance_Bond;
//           } else {
//             window.location.href = insurance_Bond;
//           }
//           return true;
//         } else {
//           Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
//           return false;
//         }
//       } catch (error) {
//         console.error('Error saving data:', error);
//         Swal.showValidationMessage('Something went wrong. Please try again.');
//         return false;
//       }
//     },
//   })
//     .then((result) => {
//       if (result.isConfirmed) {
//         console.log('Project created successfully!');
//       }
//     })
//     .catch((errorMessage) => {
//       Swal.fire({
//         icon: 'error',
//         title: 'Error',
//         text: errorMessage,
//       });
//     });
// };

  const openBondPopup = () => {
    MySwal.fire({
      title: '',
      html: `            
            <div class="popup-container">        
          <div class="popup-body">
          <div class="popup-field">
            <label for="selectSubmission">Select Submission *</label>
            <select id="selectSubmission" style="width: 200px; border-radius: 0;" class="popup-input">
            <option value="" selected>Select Submission</option>
              <option value="Performance Bond">Performance Bond</option>
              <option value="Insurance Bond">Insurance Bond</option>
            </select>
          </div>

          <div class="popup-field">
              <label for="expiryDate">Expiry Date *</label>
              <input style="width: 200px; border-radius: 0;" id="expiryDate" type="date" class="popup-input">
            </div>

          <div class="popup-field">
                <label for="submissionType">Submission Type *</label>
                <select id="submissionType" style="width: 200px; border-radius: 0;" class="popup-input">
                <option value="" selected>Submission Type</option>
                    <option value="Soft Copy">Soft Copy</option>
                    <option value="Hard copy">Hard copy</option>
                </select>
            </div>            
          </div>
        </div>
          `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      preConfirm: async () => {
        const selectSubmission = document.getElementById('selectSubmission').value;
        const expiryDate = document.getElementById('expiryDate').value;
        const submissionType = document.getElementById('submissionType').value;

        if (!expiryDate || !selectSubmission || !submissionType) {
          Swal.showValidationMessage('Please fill out all required fields');
          return false;
        }
        const sendData = {
          bim360_account_id: accountId,
          user_id: userId,
          user_group: process.env.REACT_APP_USER_GROUP,
          project_id: defaultProjectNumber,
          submission: selectSubmission,
          expiry_date: expiryDate,
          submission_type: submissionType,
        };

        // console.log('sendData....',sendData);
        
        try {
          Swal.showLoading();

          const requestOptions = {
            method: 'POST',
            // headers: {
            //   'Content-Type': 'application/json',
            //   'ngrok-skip-browser-warning': '69420',
            // },
            body: JSON.stringify(sendData),
          };

          const response = await queuedApiFetch('/construction/insert_update_per_ins_bond', requestOptions);
          const result = await response;

          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {            
            // showToast.success('Project Created Successfully');
            // return true; // Close the popup
            if(selectSubmission == 'Performance Bond'){
              window.location.href = performance_Bond;
              return true;
            } else {
              window.location.href = insurance_Bond;
              return true;
            }
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Project created successfully!');
      }
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    });
  };


  const openSOIPopup = () => {
    MySwal.fire({
      title: '',
      html: `
            <div class="popup-container">        
          <div class="popup-body">
          <div class="popup-field">
            <label for="SOINumber">Enter SOI Number *</label>
            <input id="SOINumber" type="text" class="popup-input" placeholder="Enter a SOI Number">
          </div>
          <div class="popup-field">
            <label for="RVWNumber">Select RVW number *</label>
            <select id="RVWNumber" style="width: 200px; border-radius: 0;" class="popup-input">
            <option value="" selected>Select RVW Number</option>
            </select>
          </div>                     
          </div>
        </div>
          `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      didOpen: async () => {

        const getProjectDetails = localStorage.getItem('projectDetails');
        const selectedProjectDetail = JSON.parse(getProjectDetails);
        const projectNum = selectedProjectDetail.projectNumber;
        //const projectName = selectedProjectDetail.projectName;
        const getUserDetails = localStorage.getItem('userDetails');
        const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
        //const company_id = userDetails ? userDetails.default_company_id : '';
        const user_id = userDetails ? userDetails.id : '';
        const autodesk_id = userDetails ? userDetails.autodesk_id : '';

        try {
          Swal.showLoading();

          const requestOptions = {
            method: 'GET',
            // headers: {
            //   'Content-Type': 'application/json',
            //   'ngrok-skip-browser-warning': '69420',
            // },

          };

          const response = await queuedApiFetch(`/payment/rvw_nos_for_soi?project_id=${projectNum}`, requestOptions);
          const result = await response;

          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {

            var select1 = document.getElementById('RVWNumber');

            for (var i = 0; i < result.data.length; i++) {
              const option = document.createElement("option");
              option.textContent = result.data[i];
              option.value = result.data[i];
              select1.appendChild(option);
            };

            Swal.hideLoading();
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
      preConfirm: async () => {
        const SOINumber = document.getElementById('SOINumber').value;
        const RVWNumber = document.getElementById('RVWNumber').value;

        if (!SOINumber || !RVWNumber) {
          Swal.showValidationMessage('Please fill out all required fields');
          return false;
        }
        const sendData = {
          project_id: defaultProjectNumber,
          RVW_No: RVWNumber,
          SOI_No: SOINumber,
        };

        // console.log('sendData....',sendData);

        try {
          Swal.showLoading();

          const requestOptions = {
            method: 'POST',
            // headers: {
            //   'Content-Type': 'application/json',
            //   'ngrok-skip-browser-warning': '69420',
            // },
            body: JSON.stringify(sendData),
          };

          const response = await queuedApiFetch('/payment/update_rvw_soi', requestOptions);
          const result = await response;

          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
            // showToast.success('Project Created Successfully');
            // return true; // Close the popup
            console.log(SOI_URL);
            window.location.href = SOI_URL;
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('SOI updated successfully!');
      }
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    });
  };


  const openCSCPopup = () => {
    MySwal.fire({
      title: '',
      html: `
            <div class="popup-container">        
          <div class="popup-body">
          <div class="popup-field">
            <label for="selectSubmission">Select Submission *</label>
            <select id="selectSubmission" style="width: 200px; border-radius: 0;" class="popup-input">
            <option value="" selected>Select Submission</option>
              <option value="FSC">FSC</option>
              <option value="CSC">CSC</option>
              <option value="TOP">TOP</option>
            </select>
          </div>
          <div class="popup-field">
              <label for="approvalDate">Approval Date *</label>
              <input style="width: 200px; border-radius: 0;" id="approvalDate" type="date" class="popup-input">
            </div>                   
          </div>
        </div>
          `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      preConfirm: async () => {
        const selectSubmission = document.getElementById('selectSubmission').value;        
        const approvalDate = document.getElementById('approvalDate').value;

        if (!selectSubmission || !approvalDate) {
          Swal.showValidationMessage('Please fill out all required fields');
          return false;
        }
        const sendData = {
          // bim360_account_id: accountId,
          // user_id: userId,
          // user_group: process.env.REACT_APP_USER_GROUP,
          project_id: defaultProjectNumber,
          submission: selectSubmission,
          approval_date: approvalDate,          
        };

        // console.log('sendData....',sendData);
        
        try {
          Swal.showLoading();
          const requestOptions = {
            method: 'GET',
            // headers: {              
            //   'ngrok-skip-browser-warning': '69420',
            // },            
          };
          const response = await queuedApiFetch(`/construction/update_projectsubmissiondate?project_id=${defaultProjectNumber}&submission=${selectSubmission}&approval_date=${approvalDate}`,requestOptions);
          const result = await response;
          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {            
            // showToast.success('Project Created Successfully');
            // return true; // Close the popup
            if(selectSubmission == 'FSC'){
              window.location.href = FSC_URL;

            } else if(selectSubmission == 'CSC'){
              window.location.href = CSC_URL;

            }else {
              window.location.href = TOP_URL;
            }
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Project created successfully!');
      }
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    });
  };

  const PIRPopup = () => {
    Swal.fire({
      // title: 'Please upload files in folder `A` before proceeding',
      title: 'Please upload files in folder [Post Implementation Review] before proceeding',
      showCancelButton: true,
      confirmButtonText: 'Upload',
      cancelButtonText: 'Proceed',
      showCloseButton: true,
      width: '700px',
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.open(PIR_UPLOAD_URL, "_blank")
        //window.location.replace(PIR_UPLOAD_URL);
        //window.submitform(t_pir_form,formData)
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // window.location.replace(PIR_PROCEED_URL);
        window.submitform(t_pir_form,formData,'Post Construction_Submit Form');
      }
    });
  };


  const appraisalPopup = () => {
    Swal.fire({
      title: 'Please select from below',
      showCancelButton: true,
      confirmButtonText: 'Contractor',
      cancelButtonText: 'Consultant',
      showCloseButton: true,
      width: '700px',
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // window.location.replace(APPR_CONTRACTOR);
        window.submitform(t_cont_appraisal,formData,'Post Construction_Submit Form');        
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // window.location.replace(APPR_CONSULTANT);
        window.submitform(t_cons_appraisal,formData,'Post Construction_Submit Form');
      }
    });
  };

  // const submitForm = (template_name, formData, menu) => {
  //   const form = document.createElement('form');
  //   form.method = 'POST';
  //   //form.action = actionUrl;
  //   form.action = `${process.env.REACT_APP_BACKEND_URL}/form_template/form_post`;
  
  //    formData.append('account_id', accountId);
  //    formData.append('project_id', defaultProjectNumber);
  //     //added 2 parameters for the url
  //     formData.append('menu', menu);
  //     formData.append('nususer', parametervalue);
  
  //   formData.append('template_name', template_name);
  //   // form.enctype = 'multipart/form-data'; // Required for file uploads
  
  //   // Append FormData fields as hidden inputs
  //   for (const [key, value] of formData.entries()) {
  //       const input = document.createElement('input');
  //       input.type = 'hidden';
  //       input.name = key;
  //       input.value = value;
  //       form.appendChild(input);
  //   }
  
  //   document.body.appendChild(form);
  //   form.submit();
  // };

  // const cons_cont_sts = (
  //     expectedCompany,
  //     // accountAdminPermissions = [],
  //     projectAdminRoles = []
  //   ) => {
  //     const sts=(
  //       (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')  && userRoleManual?.length===0) ||        
  //       projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
  //     );
  //     return sts;
  //   };

  const cons_cont_sts = (
      expectedCompany,
      // accountAdminPermissions = [],
      projectAdminRoles = []
    ) => {
      console.log(projectAdminRoles);
      const sts=(
        (getUserCompanyDetails === expectedCompany && proj_access_level === true) ||        
        projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
      );
      return sts;
    };

    // const cons_cont_sts = (
    //   expectedCompany,
    //   // accountAdminPermissions = [],
    //   projectAdminRoles = []
    // ) => {
    //   const sts=(
    //     (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin'))  || (userRoleManual?.length===0 ||        
    //     projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))
    //   );
    //   return sts;
    // };

  return (
    // <div style={{ overflowY: "auto", width: "100%", height: `calc(100% - ${buttonId === 'SubmitForm' ? "330px":"120px"})`, background: "#fff",  marginBottom: "20px" }}></div>
    <div style={{ overflowY: "auto", width: "100%", height: `calc(100% - ${buttonId === 'SubmitForm' ? "175px":"110px"})`, background: "#fff",  marginBottom: "20px" }}>
      <div style={{ display: "flex", justifyContent: "center", background: "white" }}>
        {loading && <FullscreenLoader />} 
        <div className="submit-doc-container" style={{ margin: "0 0 15px 0" }}>
          <div className="title">Select to submit documents / request</div>
      
          <div className="button-container">
            {/* {buttonId === 'SubmitForm' && (  
               (cons_cont_sts("NUS",['Consultant'])) ?(
                  <>
                    <button className="other" onClick={() => PIRPopup()}>PIR form</button>
                    <button className="other" onClick={() => window.location.href = CAP_URL}>Capitalization form</button>
                    <button className="other" onClick={() => window.location.href = FIN_URL}>Final Account</button>
                  </>
              ) : (cons_cont_sts("NUS",['Project Manager (PM)']))?(
                  <>
                    
                    <button className="other" onClick={() => window.submitform(t_proj_checklist, formData, 'Post Construction_Submit Form')}>Project Checklist</button>
                    
                    <button className="other" onClick={() => appraisalPopup()}>Appraisal</button>
                  </>
              ) : null 
            )}  */}

            { buttonId === 'SubmitForm' && (
              <>
                {(cons_cont_sts("NUS",['Consultant'])) && (
                  <>
                    <button className="other" onClick={() => PIRPopup()}>PIR form</button>
                    <button className="other" onClick={() => window.location.href = CAP_URL}>Capitalization form</button>
                    <button className="other" onClick={() => window.location.href = FIN_URL}>Final Account</button>
                  </>
                )}
                {(cons_cont_sts("NUS",['Project Manager (PM)'])) && (
                  <>
                   {/* <button className="other" onClick={() => PIRPopup()}>PIR form</button> */}
                    <button className="other" onClick={() => window.submitform(t_proj_checklist, formData, 'Post Construction_Submit Form')}>Project Checklist</button>
                    {/* <button className="other" onClick={() => window.location.href = CAP_URL}>Capitalization form</button>
                    <button className="other" onClick={() => window.location.href = FIN_URL}>Final Account</button> */}
                    <button className="other" onClick={() => appraisalPopup()}>Appraisal</button>
                  </>
                )}
              </>
              )

            }

                        { buttonId != 'SubmitForm' && (
              <>
                {(cons_cont_sts("NUS",['Contractor'])) && (
                  <>
                    <button className="other" onClick={openBondPopup}>Performance Bond and Insurance</button>
                    <button className="other" onClick={() => window.location.href = FAC_URL}>Factory Permits</button>
                    <button className="other" onClick={() => window.submitform(t_site_ho_cont, formData, 'Construction_Submit Documents/Request')}>Site handover to Contractor</button>
                    <button className="other" onClick={() => window.submitform(t_site_uti_plan, formData, 'Construction_Submit Documents/Request')}>Site utilisation plan</button>
                    <button className="other" onClick={() => window.submitform(t_high_imp_work, formData, 'Construction_Submit Documents/Request')}>FM0202 High Impact Work</button>
                    <button className="other" onClick={() => window.location.href = EOT_URL}>EOT Request</button>
                    <button className="other" onClick={() => window.location.href = DOC_URL}>Other Documents</button>
                    <button className="other" onClick={() => window.submitform(t_iso_works_form, formData, 'Construction_Submit Documents/Request')}>Isolation Work Form</button>
                    {/* <button className="other" onClick={() => window.location.href = ISO_URL}>Isolation Work Form</button> */}
                  </>
                )}
                {(cons_cont_sts("NUS",['Consultant'])) && (
                  <>
                    <button className="other" onClick={openSOIPopup}>Issue SOI</button>
                    <button className="other" onClick={openCSCPopup}>FSC/CSC/TOP</button>
                    <button className="other" onClick={() => window.submitform(t_inst_req, formData, 'Construction_Submit Documents/Request')}>Installation request (Approved set by consultant)</button>
                  </>
                )}
              </>
              )

            }

            {/* {buttonId === 'SubmitForm' && (
              <>
                <button className="other" onClick={() => PIRPopup()}>PIR form</button>
                <button className="other" onClick={() => window.submitform(t_proj_checklist, formData, 'Post Construction_Submit Form')}>Project Checklist</button>
                <button className="other" onClick={() => window.location.href = CAP_URL}>Capitalization form</button>
                <button className="other" onClick={() => window.location.href = FIN_URL}>Final Account</button>
                <button className="other" onClick={() => appraisalPopup()}>Appraisal</button>
              </>
            )} */}


            {/* {(getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
            (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
            (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && 
              (userRoleManual === 'Consultant' || userRoleManual === 'Contractor')) ? (
              <>
                {(userRoleManual === 'Consultant' || userPermission === 'account_admin' || userRoleManual === '') && (
                  <>
                    <button className="other" onClick={openBondPopup}>Performance Bond and Insurance</button>
                    <button className="other" onClick={() => window.location.href = FAC_URL}>Factory Permits</button>
                    <button className="other" onClick={() => window.submitform(t_site_ho_cont, formData, 'Construction_Submit Documents/Request')}>Site handover to Contractor</button>
                    <button className="other" onClick={() => window.submitform(t_site_uti_plan, formData, 'Construction_Submit Documents/Request')}>Site utilisation plan</button>
                    <button className="other" onClick={() => window.submitform(t_high_imp_work, formData, 'Construction_Submit Documents/Request')}>FM0202 High Impact Work</button>
                    <button className="other" onClick={() => window.location.href = EOT_URL}>EOT Request</button>
                    <button className="other" onClick={() => window.location.href = DOC_URL}>Other Documents</button>
                    <button className="other" onClick={() => window.location.href = ISO_URL}>Isolation Work Form</button>
                  </>
                )}
                {(userRoleManual === 'Contractor' || userPermission === 'account_admin' || userRoleManual === '') && (
                  <>
                    <button className="other" onClick={openSOIPopup}>Issue SOI</button>
                    <button className="other" onClick={openCSCPopup}>FSC/CSC/TOP</button>
                    <button className="other" onClick={() => window.submitform(t_inst_req, formData, 'Construction_Submit Documents/Request')}>Installation request (Approved set by consultant)</button>
                  </>
                )}
              </>
            ) : null} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmitDocumentsRequestiframe;
